import { render, staticRenderFns } from "./messageH5.vue?vue&type=template&id=4c2b67a1&scoped=true&lang=pug"
import script from "./messageH5.vue?vue&type=script&lang=js"
export * from "./messageH5.vue?vue&type=script&lang=js"
import style0 from "./messageH5.vue?vue&type=style&index=0&id=4c2b67a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b67a1",
  null
  
)

export default component.exports